import React from 'react'
import {Route} from "react-router-dom";
import loadable from "../../loadable";
import PubSub from "pubsub-js";
import Utils from "../../public/utils";
import noPermissions from "../../config/noPermissions/noPermissions";
import {connect} from "react-redux";

const MobileFriend = loadable(() => import('./mobilefriend/index'));
const GroupChatFriend = loadable(() => import('./groupchatfriend/index'));
/**
 * @author Yaochao
 * @date 2021/12/14 14:11
 * @description
 */

class Drainage extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div>
                {
                    this.props.subInfo.isSub == 0 ?
                        <>
                            <Route path={this.props.match.url + "/mobilefriend"}
                                   component={MobileFriend}/>
                            <Route path={this.props.match.url + "/groupchatfriend"}
                                   component={GroupChatFriend}/>
                        </> : this.props.subInfo.isSub == 1 ?
                        <>
                            {/*手机号加好友*/}
                            <Route path={this.props.match.url + "/mobilefriend"}
                                   component={Utils.wxWorkHelperProJurisdiction(this.props.subInfo.permissionConf,'drainage','drainage_mobilefriend') ?
                                       MobileFriend : noPermissions}/>
                            {/*群加好友*/}
                            <Route path={this.props.match.url + "/groupchatfriend"}
                                   component={Utils.wxWorkHelperProJurisdiction(this.props.subInfo.permissionConf,'drainage','drainage_groupchatfriend') ?
                                       GroupChatFriend : noPermissions}/>
                        </> : <></>
                }
            </div>
        )
    }
}

export default connect(state=>{
    const {subReducer} = state
    return {
        subInfo:subReducer
    }
})(Drainage)